import React from 'react';
import Container from '@mui/material/Container';
import { SpeakerComponent } from './SpeakersComponent';

export default function Speakers() {

    return (
        <div className="container">
            <Container maxWidth="xl">
                <SpeakerComponent/>
            </Container>
        </div>
        
    )
}